import React from 'react'
import logo from "assets/img/logo_z_obwodka.png";
import ikona1 from 'assets/img/ikona01.png'
import ikona2 from 'assets/img/ikona02.png'
import ikona3 from 'assets/img/ikona03.png'
import ikona4 from 'assets/img/ikona04.png'
import ikona6 from 'assets/img/ikona06.png'
import ikona5 from 'assets/img/ikona05.png'
import background from 'assets/img/mainBackground.jpg'
import { useNavigate } from 'react-router-dom'

const LandingPageHeader = () => {
    document.documentElement.classList.remove("nav-open");
    React.useEffect(() => {
        document.body.classList.add("product-page");
        return function cleanup() {
            document.body.classList.remove("product-page");
        };
    });

    const navigate = useNavigate()
    const goToMain = () => {
        navigate('/')
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            navigate('/')
        }
    }

    return (
        <>
            <div
                className="page-header page-header-small"
                style={{
                    backgroundImage: `url(${background})`,
                }}
            >
                <div style={{bottom:"0px", left:"calc(50% - 100px)", position:"absolute", width:"200px", zIndex:"1000"}}>
                    <img role={'button'} tabIndex={'0'} alt={'Logo - zdjęcie'} aria-label={'Przejdź na stronę główną'} src={logo} width='200px' style={{cursor: 'pointer'}}
                         onKeyDown={handleKeyDown}
                         onClick={(e) => {
                             goToMain();
                             window.focus();
                             window.scrollTo(0, 0);
                         }}></img>

                </div>
                {/* ikona1 */}
                <div style={{bottom:"120px", right:"calc(295px - 0px)", position:"absolute", width:"80px", zIndex:"1000"}}>
                    <img alt={'ikona1'} src={ikona1} width='80px'></img>
                </div>
                <div style={{bottom:"190px", right:"calc(175px - 0px)", position:"absolute", width:"140px", zIndex:"1000"}}>
                    <img alt={'ikona2'} src={ikona2} width='140px'></img>
                </div>
                <div style={{bottom:"205px", right:"calc(70px - 0px)", position:"absolute", width:"80px", zIndex:"1000"}}>
                    <img alt={'ikona3'} src={ikona3} width='80px'></img>
                </div>
                <div style={{bottom:"115px", left:"calc(100px - 0px)", position:"absolute", width:"100px", zIndex:"1000"}}>
                    <img alt={'ikona6'} src={ikona6} width='100px' ></img>
                </div>
                <div style={{bottom:"115px", left:"calc(225px - 0px)", position:"absolute", width:"100px", zIndex:"1000"}}>
                    <img alt={'ikona5'} src={ikona5} width='100px' ></img>
                </div>
                <div style={{bottom:"225px", left:"calc(175px - 0px)", position:"absolute", width:"80px", zIndex:"1000"}}>
                    <img alt={'ikona4'} src={ikona4} width='80px'></img>
                </div>


                <div style={{bottom:'103px', position:"absolute", height: "4px", width:'100%', backgroundColor:"white", zIndex:"900", opacity:"0.8"}}></div>
                <div style={{bottom:'88px', position:"absolute", height: "8px", width:'100%', backgroundColor:"white", zIndex:"900", opacity:"0.8"}}></div>

                <div style={{bottom:'60px', position:"absolute", height: "20px", width:'100%', backgroundColor:"white", zIndex:"900", opacity:"0.3"}}></div>

                <div style={{bottom:'0px', position:"absolute", height: "60px", width:'100%', backgroundColor:"white", opacity:"0.6", zIndex:"800"}}>

                </div>
                <div style={{bottom:'0vh', position:"absolute", height: "30px", width:'100%', backgroundColor:"white", zIndex:"900", opacity:"1"}}></div>

            </div>
        </>
    );
}

export default LandingPageHeader
